import * as React from "react"
import { Typography } from "components"
import { Transaction } from "types/transaction"

const errorStaus = ["در انتظار پرداخت", "لفو شده"]

const TransactionResult: React.FC<Transaction> = ({
	order_status,
	created_at,
}) => {
	return (
		<div className="pb-1">
			{errorStaus.includes(order_status) && (
				<Typography variant="h6" color="danger">
					متاسفانه پرداخت ناموفق بود
				</Typography>
			)}
			{order_status === "تکمیل شده" && (
				<Typography variant="h6" color="success">
					پرداخت با موفقیت انجام شد
				</Typography>
			)}
			{order_status === "تکمیل شده" && (
				<Typography color="success" variant="body1">
					تاریخ تراکنش: {created_at}
				</Typography>
			)}
		</div>
	)
}

export default TransactionResult
